<div class="h-h">
  <div>
    @if (!acS.mS$()?.without) {
      <mn-svg
        data-ui-sound
        mnClickArea
        class="c-p cu-p"
        name="arrow-left"
        mnAnalyticsClick="back_sidebar_bets"
        (click)="close($event, true)" />
    }
    <b class="t-h u-c">{{ "bets.title" | mnTranslate }}</b>
  </div>
  <mn-button aEvent="limits_close" (clicked)="close($event, false)">
    <mn-svg name="close" />
  </mn-button>
</div>
<div class="content">
  <div class="bet g-4 header t-s c-t u-c">
    <span>{{ "bet.time" | mnTranslate }}</span>
    <span>{{ "bet.title" | mnTranslate }}</span>
    <span>{{ "bet.mult" | mnTranslate }}</span>
    <span>{{ "bet.win" | mnTranslate }}</span>
    @if (fair()) {
      <span class="t-a-r icon-only"></span>
    }
  </div>
  @for (item of its(); track item.round_id) {
    <div class="bet g-4 t-s c-p">
      <div class="g-4 f-c">
        <span>{{ item.created_at | date: "dd.MM.yyyy" }}</span>
        <p class="t-s-s c-se">{{ item.created_at | date: "HH:mm:ss" }}</p>
      </div>
      <span class="w-b-a">{{ item.bet }}</span>
      <span>{{ item.multiplier }}x</span>
      <span class="w-b-a {{ item.wC }}">{{ item.win }}</span>
      @if (fair()) {
        <span class="t-a-r icon-only">
          <mn-svg
            data-ui-sound
            mnClickArea
            class="c-p cu-p"
            name="shield"
            mnAnalyticsClick="open_bet_info_modal"
            (click)="info($event, item.round_id)" />
        </span>
      }
    </div>
  } @empty {
    <div class="empty f-c">
      <img class="clock" alt="clock" decoding="async" src="assets/images/webp/common/clock.webp" />
      <b class="t-r">{{ "bets.empty.title" | mnTranslate }}</b>
      <span class="c-se t-s">{{ "bets.empty.description" | mnTranslate }}</span>
    </div>
  }
</div>
